import React from 'react'
import ExpenseForm from './ExpenseForm'
import './NewExpenses.css'

const NewExpenses = (props) => {
    const newExpenseHandler = (newExpenseDataData) => {
        const expenseData = {
            ...newExpenseDataData, id: Math.random().toString()
        }
        props.onAddExpense(expenseData);
    }
    return (
        <div className='new-expense'>
            <ExpenseForm onExpenseHandler={newExpenseHandler}/>
        </div>
    )
}

export default NewExpenses
